import EditableDetailPanel from 'Components/Generic/DetailPanel/EditableDetailPanel';
import PropTypes from 'prop-types';
import { useState } from 'react';
import RequestInformationTable from './RequestInformationTable';
import { useEditableRequestInformation } from './useEditableRequestInformation';

const RequestInformationPanel = ({
  requestObject = {},
  title = 'Details',
  excludeIsRadioactive = false,
  showRequestId = false,
  isNew = false,
  editable,
}) => {
  const [editState, setEditState] = useState(isNew);
  const {
    editableTable,
    footer,
    request: updatedRequest,
  } = useEditableRequestInformation({
    requestObject,
    isNew,
    setEditState,
  });

  const renderRequestDetails = () => {
    return (
      <RequestInformationTable
        request={{ ...requestObject, ...updatedRequest }}
        showRequestId={showRequestId}
        excludeIsRadioactive={excludeIsRadioactive}
      />
    );
  };

  return (
    <EditableDetailPanel
      editable={editable || isNew}
      title={title}
      renderChild={(inEditState) => {
        return isNew || inEditState ? editableTable : renderRequestDetails();
      }}
      renderFooter={() => footer}
      parentEditState={editState}
      hideToggle={isNew}
    />
  );
};

RequestInformationPanel.propTypes = {
  requestObject: PropTypes.object,
  title: PropTypes.string,
  excludeIsRadioactive: PropTypes.bool,
  showRequestId: PropTypes.bool,
  isNew: PropTypes.bool,
  editable: PropTypes.bool,
};

export default RequestInformationPanel;
